"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Point = _interopRequireDefault(require("./Point"));

var Vector = /*#__PURE__*/function () {
  /** @private {!Point} */

  /** @private {!Point} */

  /**
   * @param {!Point} start
   * @param {!Point} end
   */
  function Vector(start, end) {
    (0, _classCallCheck2["default"])(this, Vector);
    (0, _defineProperty2["default"])(this, "_start", void 0);
    (0, _defineProperty2["default"])(this, "_end", void 0);
    this._start = start;
    this._end = end;
  }
  /** @returns {!Point} */


  (0, _createClass2["default"])(Vector, [{
    key: "getIntersectionPoint",

    /**
     * @param {!Vector} otherVector
     * @returns {!Point}
     */
    value: function getIntersectionPoint(otherVector) {
      var n1 = this._start.x * this._end.y - this._start.y * this._end.x;
      var n2 = otherVector.start.x * otherVector.end.y - otherVector.start.y * otherVector.end.x;
      var n3 = 1.0 / (this.dX * otherVector.dY - this.dY * otherVector.dX);
      var x = +((n2 * this.dX - n1 * otherVector.dX) * n3).toFixed(6);
      var y = +((n2 * this.dY - n1 * otherVector.dY) * n3).toFixed(6);
      return new _Point["default"](x, y);
    }
    /**
     * @param point
     * @returns {boolean}
     */

  }, {
    key: "isRightOfPoint",
    value: function isRightOfPoint(point) {
      return (this.end.x - this.start.x) * (point.y - this.start.y) > (this.end.y - this.start.y) * (point.x - this.start.x);
    }
    /**
     * Checks if object is an instance of Vector
     *
     * @param inputObject
     * @returns {boolean}
     */

  }, {
    key: "start",
    get: function get() {
      return this._start;
    }
    /** @returns {!Point} */

  }, {
    key: "end",
    get: function get() {
      return this._end;
    }
    /** @returns {number} */

  }, {
    key: "dX",
    get: function get() {
      return this._end.x - this._start.x;
    }
    /** @returns {number} */

  }, {
    key: "dY",
    get: function get() {
      return this._end.y - this._start.y;
    }
    /** @returns {number} */

  }, {
    key: "length",
    get: function get() {
      return Math.sqrt(Math.pow(this.dX, 2) + Math.pow(this.dY, 2));
    }
  }], [{
    key: "isVector",
    value: function isVector(inputObject) {
      return inputObject instanceof Vector;
    }
    /** given a distance get a point that lies on the same vector from the end point
     * @param {Vector} vector
     * @param {number} distance
     * @returns {Point}
     */

  }, {
    key: "getPointFromEnd",
    value: function getPointFromEnd(vector, distance) {
      if (!Vector.isVector(vector)) {
        throw new Error('Vector is required');
      }

      var length = vector.length;
      return new _Point["default"](vector.end.x + distance * vector.dX / length, vector.end.y + distance * vector.dY / length);
    }
  }]);
  return Vector;
}();

exports["default"] = Vector;